var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartDefault2422 = function SvgHeartDefault2422(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#949596",
    strokeWidth: 2,
    d: "M1 6.6a5.66 5.66 0 0 1 1.647-4.002A5.42 5.42 0 0 1 6.581 1h.024A6.1 6.1 0 0 1 10.21 2.16q.567.409 1.04.946l.751.857.752-.857a6.2 6.2 0 0 1 1.039-.946 6.1 6.1 0 0 1 3.604-1.158h.024a5.42 5.42 0 0 1 3.934 1.597A5.66 5.66 0 0 1 23 6.6c0 2.359-1.134 4.558-2.89 6.662-1.758 2.107-4.043 4.008-6.185 5.786-.742.616-1.243.96-1.922 1.324-.699-.383-1.272-.792-2.027-1.421-2.131-1.775-4.39-3.66-6.127-5.749C2.116 11.118 1 8.942 1 6.601Z"
  })));
};
export default SvgHeartDefault2422;